require('./style.less');

var ESPageView = require('../view');

/* note: whitespace must be removed from template */
var subTemplate = require('./template.hbs');

module.exports = ESPageView.extend({
    subTemplate: subTemplate,
    sectionLabel: 'File Cabinet Fields',
    serializeData: function() {
        return {
            pgLbl: this.model.get('pgLbl'),
            pgText: this.subTemplate({
                /* field name X markup from es with hit */
                fieldHits: this.model.get('pgText')
            })
        };
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/page/fcFields/view.js
 ** module id = 544
 ** module chunks = 0
 **/